/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import Layout from "../../../../components/layout/Layout";
import Loader from "../../../../components/Loader";
import { toast } from "react-toastify";
import { Button, Form, Modal, Col, Row } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { MdModeEditOutline } from "react-icons/md";
import { CiCircleCheck } from "react-icons/ci";
import { useLocation } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useNavigate } from "react-router-dom";
// React Icons
import { Helmet } from "react-helmet";
import { ViewInvoiceModal, handleViewPdf } from "./ViewInvoiceModal";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import DownloadForOfflineSharpIcon from "@mui/icons-material/DownloadForOfflineSharp";
import { getViewInvoices, mobileScroll, readCookie } from "common/FunctionUtils";
import InvoiceFilter from "./InvoiceFilter";
import { LOCALES, INVOICE_STATUS } from "common/constants";
import InvoiceEditAmountModal from "./InvoiceEditAmountModal";
import CancelInvoiceModal from "./CancelInvoiceModal";
import EditInvoiceModal from "./EditInvoiceModal";
import { getInvoiceData } from '../../../../../src/redux/auth/authSlice';
import { ARTICLE_NUMBERS } from '../../../../../src/common/constants';
import { convertHouseworkType } from '../../../../../src/common/FunctionUtils';
import {HourlyWages} from '../../../../../src/views/dashboard/economy/Articles';
import { useDispatch } from 'react-redux';
import {articlesNumber} from '../../../../../src/common/StringUtils';
import {costPerDayArticle, costPerWeekArticle, costPerMonthArticle, costAgreementArticle} from '../../../../../src/views/dashboard/economy/Articles';
const Invoices = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const pageCount = 10;
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [deductionAmount, setDeductionAmount] = useState(0);
  const [activePagination, setactivePagination] = useState(1);
   const [getEditInvoiceData, setGetEditInvoiceData] = useState({});

  const [showDetails, setShowDetails] = useState({
    invoiceDetails: null,
    expresePayment: null,
    expresePolicy: false,
    closeModal: false,
  });
  const navigate = useNavigate();
    const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const isLoginWithBankId = Number(readCookie("logged"));
  const styles = document.createElement("style");
  styles.innerHTML = `
      @keyframes blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
    
      @keyframes glow {
        0% { text-shadow: 0 0 5px lime, 0 0 10px lime, 0 0 15px lime; }
        50% { text-shadow: 0 0 10px lime, 0 0 20px lime, 0 0 30px lime; }
        100% { text-shadow: 0 0 5px lime, 0 0 10px lime, 0 0 15px lime; }
      }
    `;
  document.head.appendChild(styles);

  const [getPdfData, setgetPdfData] = useState(null);
  const [showAmountModal, setShowAmountModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState(null);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelInvoiceNumber, setCancelInvoiceNumber] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editInvoiceData, setEditInvoiceData] = useState({});
  const [formData, setFormData] = useState({
    description: "",
    vat: "",
    dueDate: "",
    referenceName: "",
  });

  const isDevelopment = () => import.meta.env.VITE_NODE_ENV !== 'production';
  
  const handleEditButtonClick = async (invoiceNumber, dueDate) => {
    // Check if due date has expired
    if (dueDate) {
      const currentDate = new Date();
      const invoiceDueDate = new Date(dueDate);
      
      // Set both dates to start of day for accurate comparison
      currentDate.setHours(0, 0, 0, 0);
      invoiceDueDate.setHours(0, 0, 0, 0);
      
      if (currentDate >= invoiceDueDate) {
        toast.warning(t("Your due date has expired, so no further changes are allowed."));
        return;
      }
    }

    try {
      setLoading(true);
      const URL = `/invoice/invoice-detail-for-edit/${invoiceNumber}`;

      const result = await axios.get(URL);
      setGetEditInvoiceData(result.data.response);
      if (result?.status === 200) {
        const fetchInvoices = result?.data?.response;
        const {
          vat,
          amount,
          isFixed,
          customer,
          showDates,
          invoiceNumber,
          description,
          invoiceFreelancer,
          workingHours,
          holidaySavings,
          holidaySavingsFee,
          pension,
          pensionAmount,
          file,
        } = fetchInvoices;
        const filteredWorkingHours = workingHours?.filter((item) => {
          return (
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.TRAVEL &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
          );
        });

        const freelancers =
          invoiceFreelancer?.length > 0
            ? invoiceFreelancer?.map((item) => ({
              amount: item.amount,
              userId: item.userId,
               holidaySavings: item.holidaySavings,
              holidaySavingsFee: item.holidaySavingsFee,
              pension: item.pension,
              pensionAmount: item.pensionAmount,
              signUpUser: item.freelancerDetails,
            }))
            : [];

        const invoiceHours = [];
       if (freelancers && freelancers.length !== 0) {
          freelancers?.forEach((freelancer) => {
            let workingHourObject = {};
            const freelancerWorkingHours = filteredWorkingHours?.filter((item) => item.userId === freelancer?.userId);
            freelancerWorkingHours?.forEach((item) => {
              
              const { amountPerUnit, number, articleNumber, workingDate, userId, houseworkType, dateId, id, } = item;

              workingHourObject[dateId ? dateId : workingDate.split('T')[0]] = {
                      units: number,
                      id: id,
                      userId: userId,
                      amount: amountPerUnit,
                      houseworkType: {
                        value: houseworkType,
                        name: convertHouseworkType(houseworkType),
                      },
                      article:
                        articleNumber === articlesNumber.HourlyWages
                          ? HourlyWages
                          : articleNumber === articlesNumber.otherCost
                            ? otherCost
                            : articleNumber === articlesNumber.costPerDay
                              ? costPerDayArticle
                              : articleNumber === articlesNumber.costPerWeek
                                ? costPerWeekArticle
                                : articleNumber === articlesNumber.costPerMonth
                                  ? costPerMonthArticle
                                  : articleNumber === articlesNumber.costAgreement
                                    ? costAgreementArticle
                                    : articleNumber === articlesNumber.ExpenditureAccordingToTheAttachedPDF
                                      ? ExpenditureAccordingToTheAttachedPDF
                                      : '',
                    }

            });
             invoiceHours.push(workingHourObject);
          });
        }else {
          let array = [];
          filteredWorkingHours?.forEach((item) => {
            const { amountPerUnit, number, articleNumber, workingDate, houseworkType, dateId, id, userId } = item;
            array = [
              {
                ...array[0],
                [dateId ? dateId : workingDate.split('T')[0]]: {
                  units: number,
                  id: id,
                  userId: userId,
                  amount: amountPerUnit,
                  houseworkType: {
                    value: houseworkType,
                    name: convertHouseworkType(houseworkType),
                  },
                  article:
                    articleNumber === articlesNumber.HourlyWages
                      ? HourlyWages
                      : articleNumber === articlesNumber.otherCost
                        ? otherCost
                        : articleNumber === articlesNumber.costPerDay
                          ? costPerDayArticle
                          : articleNumber === articlesNumber.costPerWeek
                            ? costPerWeekArticle
                            : articleNumber === articlesNumber.costPerMonth
                              ? costPerMonthArticle
                              : articleNumber === articlesNumber.costAgreement
                                ? costAgreementArticle
                                : articleNumber === articlesNumber.ExpenditureAccordingToTheAttachedPDF
                                  ? ExpenditureAccordingToTheAttachedPDF
                                  : '',
                },
              },
            ];
          });
          invoiceHours.push(...array);
        }
        const invoiceFile = Array(freelancers.length).fill([]);
        // const element = invoiceHours.splice(invoiceHours.length - 1, 1)[0];
        // invoiceHours.splice(0, 0, element);
        // freelancers?.splice(freelancers.length - 1, 1);
        const otherArticles = workingHours?.filter((item) => {
          return (
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.TRAVEL ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
          );
        }) .map((item) => {
          if (item.foodAllowance && item.totalDayOfTravels) {
            return {
              ...item,
              foodAllowance: item.foodAllowance / item.totalDayOfTravels
            };
          }
          return item;
        });

        const selectedData = {
          selectedCustomer: customer,
          description,
          freelancer: freelancers,
          invoiceHours,
          showDates,
          invoiceNumber,
          vat,
          isFixed,
          amount,
          invoiceFile,
          fetchInvoices,
          otherArticles,
          holidaySavings,
          holidaySavingsFee,
          pension,
          pensionAmount,
        };
        setLoading(false);
        dispatch(getInvoiceData(selectedData));
      } else {
        setLoading(false);
        toast.error('Something went wrong please try again.');
      }
     if(result.data.response.createdDate){
      if(language === 'en-us'){
      navigate(`/dashboard/invoice-tool?lang=${language}&invoiceNumber=${invoiceNumber}&edit=true&createdDate=${result.data.response.createdDate}`);}
    else if(language === 'sv-se'){
      navigate(`/instrumentbrada/faktura-verktyg?lang=${language}&invoiceNumber=${invoiceNumber}&edit=true&createdDate=${result.data.response.createdDate}`);}
    }

      else {
        navigate(`/dashboard/invoice-tool?lang=${language}&invoiceNumber=${invoiceNumber}&edit=true`);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowEditModal(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const isButtonVisible = (createdDate) => {
    const currentDate = new Date();
    const invoiceDate = new Date(createdDate);
    const diffTime = Math.abs(currentDate - invoiceDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 5;
  };
  const handleCancelButtonClick = (invoiceNumber) => {
    setShowCancelModal(true);
    setCancelInvoiceNumber(invoiceNumber);
  };

  const handleCancelModalClose = () => {
    setShowCancelModal(false);
  };

  const handleConfirmCancel = () => {
    toast.success(t("The invoice cancellation request has been successfully submitted."));
    setShowCancelModal(false);
  };

  const handleAmountButtonClick = async (invoiceNumber, invoiceAmount) => {
    setSelectedInvoiceNumber(invoiceNumber);
    setAmount(invoiceAmount);
    setShowAmountModal(true);
    try {
      setLoading(true);
      const res = await getViewInvoices(invoiceNumber);
      if (res?.status === 200) {
        setLoading(false);
        const data = res?.data?.response;
        setEditInvoiceData(data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(t(err?.response?.data?.message));
    }
  };

  const handleAmountModalClose = () => {
    setShowAmountModal(false);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setAmount(value);
    }
  };

  const createdInvoicePopup = async () => {
    if (searchParams.get("invoiceNumber") && invoices.length > 0) {
      window.scrollTo(0, 0);
      setLoading(true);
      const result = await getViewInvoices(Number(searchParams.get("invoiceNumber")));
      if (result?.status === 200) {
        setLoading(false);
        const { response } = result?.data;

        let totalDeduction = 0;
        response?.workingHours?.forEach((value) => {
          if (value.articleNumber === "2") {
            totalDeduction += parseFloat(value.amountPerUnit) * parseFloat(value.number);
          }
        });
        setDeductionAmount(totalDeduction);
        setShowDetails((prevState) => ({
          ...prevState,
          invoiceDetails: response,
        }));
      }
    }
  };

  useEffect(() => {
    createdInvoicePopup();
  }, [invoices]);

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/invoice?pagesize=${pageCount}&pagenumber=${activePagination}&invoiceNumber=${invoiceNumber ?? 0}`);
      if (res?.status === 200) {
        setInvoices(res?.data?.response);
        setTotalCount(res?.data?.totalCount);
      }
    } catch (err) {
      toast.error(t(err?.response?.data?.message));
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };
  const location = useLocation();
  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };
  const queryParams = getQueryParams(location.search);
  let invoiceNumber = queryParams.get("invoiceNumber");
  const isAuthorize = queryParams.get("isAuthorize") == "true";
  const handleAuthorizedReminder = async () => {
    if (!invoiceNumber) {
      setError(t("Missing required parameters."));
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await axios.put(`ReminderInvoice/update-authorization?invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=${true}`);

      if (response.status === 200) {
        toast.success(`${t("Your invoice reminder for")} #${invoiceNumber} ${t("has been authorized.")}`);
        navigate(`/dashboard/economy/invoices?lang=${LOCALES.EN_US}`);
        invoiceNumber = 0;
      } else {
        toast.error(t("Failed to authorize reminder."));
      }
    } catch (err) {
      setError(err?.response?.data?.message || "An error occurred while authorizing.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilterInvoice = async () => {
    try {
      if (fromDate && toDate) {
        setLoading(true);
        const dateStringFrom = new Date(fromDate).toISOString().split("T")[0];
        const dateStringTo = new Date(toDate).toISOString().split("T")[0];

        const res = await axios.get(`/invoice?fromDate=${dateStringFrom}&toDate=${dateStringTo}&pagesize=${pageCount}&pagenumber=${activePagination}`);

        setInvoices(res?.data?.response);
        setTotalCount(res?.data?.totalCount);
        setLoading(false);
      }
    } catch (err) {
      toast.error(t(err?.response?.data?.message));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fromDate && toDate) handleFilterInvoice();
  }, [activePagination]);

  const handleClearFilter = () => {
    setToDate(null);
    setFromDate(null);
    navigate(`/dashboard/economy/invoices?lang=${LOCALES.EN_US}`);
    fetchInvoices();
  };

  useEffect(() => {
    if (!fromDate && !toDate) fetchInvoices();
  }, [activePagination, invoiceNumber]);

  const updateExpayment = async (values) => {
    try {
      setLoading(true);
      const result = await axios.put(`/invoice/${values?.invoiceNumber}`);
      if (result?.status === 200) {
        setShowDetails((prevState) => ({
          ...prevState,
          expresePayment: null,
          invoiceDetails: null,
        }));
        toast.success(t("Your express payment has been successfully processed."));
        fetchInvoices();
      }
    } catch (err) {
      toast.error(t(err?.response?.data?.message));
    } finally {
      setLoading(false);
    }
  };

  const handleExPaymentClick = (getInvoiceDetails) => {
    updateExpayment(getInvoiceDetails);
  };

  let items = [];
  let paginationNumber = totalCount / pageCount;
  for (let number = 1; number <= Math.ceil(paginationNumber); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePagination}
        onClick={() => {
          setactivePagination(number);
        }}
      >
        {number}
      </Pagination.Item>
    );
  }

  const handleShowInvoiceDetails = async (invoiceNumber) => {
    try {
      setLoading(true);
      const res = await getViewInvoices(invoiceNumber);
      if (res?.status === 200) {
        setLoading(false);
        const data = res?.data?.response;
        setgetPdfData(data);

        let totalDeduction = 0;
        data?.workingHours?.forEach((value) => {
          if (value.articleNumber === "2") {
            totalDeduction += parseFloat(value.amountPerUnit) * parseFloat(value.number);
          }
        });
        setDeductionAmount(totalDeduction);

        setShowDetails((prevState) => ({ ...prevState, invoiceDetails: data }));
      }
    } catch (err) {
      setLoading(false);
      toast.error(t(err?.response?.data?.message));
    }
  };

  const isPastDueDate = (dueDate) => {
    if (!dueDate) return false;
    const now = new Date();
    const due = new Date(dueDate);
    return now.setHours(0,0,0,0) > due.setHours(0,0,0,0);
  };

  useEffect(() => {
    mobileScroll();
  }, []);
  return (
    <Layout className="create_invoices mt-5 margin-top-767 invoice_pgs_nws space" showSidebar bgcolor>
      <Helmet>{language === LOCALES.EN_US ? <link rel="canonical" href="https://invozio.com/dashboard/economy/invoices" /> : <link rel="canonical" href="https://invozio.com/instrumentbrada/ekonomi/fakturor" />}</Helmet>
      {loading && <Loader />}

      <div className="invoice_wrapper">
        <h4 className="accident_ins font-weight-bold">{t("Your invoices")}</h4>
        <p className="mb-3">{t("invoicehere")}</p>

        <InvoiceFilter t={t} fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} handleFilterInvoice={handleFilterInvoice} setactivePagination={setactivePagination} handleClearFilter={handleClearFilter} loading={loading} invoiceNumber={invoiceNumber} />
      </div>

      <div className="table-div table-responsive table-section1 ">
        <Table className="table table-striped" striped bordered hover>
          <thead>
            <tr>
              <th className="invoice_tabeletext">{t("Invoice No")}</th>
              <th className="invoice_tabeletext">{t("Invoice Type")}</th>
              <th className="invoice_tabeletext" style={{ width: 165 }}>
                {t("Customer")}
              </th>
              <th className="invoice_tabeletext">{t("Created")}</th>
              <th className="invoice_tabeletext">{t("Due Date")}</th>

              <th className="invoice_tabeletext">{t("Amount ex. VAT")}</th>
              <th className="invoice_tabeletext">{t("Invoice Status")}</th>
              <th className="invoice_tabeletext">{t("Payment Status")}</th>
              <th className="invoice_tabeletext text-center">{t("More")}</th>
            </tr>
          </thead>

          <tbody>
            {invoices?.length ? (
              invoices.map((data, index) => {
                let title = "";
                if (!isLoginWithBankId) {
                  title = t("To access express payment, please log in with BankID.");
                } else if (data?.customer?.paymentTerm === "45" || data?.customer?.paymentTerm === "60") {
                  title = t("We don't accept express payment for 45 & 60 days.");
                } else if (data?.customer?.accountType === 1) {
                  title = t("We don't accept express payment for private customers.");
                } else if (data?.customer?.country !== "Sweden" && data?.customer?.accountType !== 1) {
                  title = t("We don't accept express payments for customers outside Sweden.");
                } else if (data?.amount > 60000) {
                  title = t("For Express Payment, there is a limit of SEK 60,000 per invoice.");
                }
                return (
                  data?.invoicePurposeType !== 3 && (
                  <tr key={data?.id}>
                    <td>{data?.invoiceNumber}</td>
                    <td>{data?.invoiceType === 2 ? t("E-invoice") : data?.invoiceType === 3 ? t("Post") : t("Email")} </td>
                    <td>{data?.customer?.name ?? ""}</td>
                    <td>{data?.createdDate?.slice(0, 10)}</td>
                    <td>{data?.dueDate?.slice(0, 10)}</td>

                    <td>{data?.amount}</td>
                    <td>
                        {
                          data.isHaveCreditInvoice
                            ? t("Credited")
                            : data?.invoiceStatus === INVOICE_STATUS.PAID
                            ? t("Paid")
                            : data?.isEmailSent
                              ? t("Approved")
                              : t("Pending")
                        }
                      </td>
                    <td>{data?.invoiceStageForUserView === INVOICE_STATUS.UNPAID ? t("Unpaid") : data?.invoiceStatus === INVOICE_STATUS.PAID ? t("Paid") : t("Partial")}</td>
                    <td className="d-flex px-4 align-items-center actions">
                      <div className="hover-text" style={{ padding: "2px 0px" }}>
                        <button id="top" className="salary_view" data-toggle="tooltip" data-placement="top" title={t("Download PDF")} onClick={() => handleViewPdf(data?.invoiceNumber, data, setLoading)}>
                          <DownloadForOfflineSharpIcon style={{ fontSize: 18 }} />
                        </button>
                      </div>
                    
                {/* this code do not remove because this code is reuseable Edit invoive Credit Invoice and Cancle invoive */}

                      {data.isSalaryCreated === false && isButtonVisible(data.createdDate) && !data.isBooked && !data?.isSalaryCreated  &&(
                  <div>
                    <button
                      id="top"
                      className="salary_view_1"
                      data-toggle="tooltip"
                      data-placement="top"
                      title={
                        data.isEditInvoiceRequested && data.isEditInvoiceRequestApproved
                          ? t("Invoice edits have been approved")
                          : data.isEditInvoiceRequested && data.isEditInvoiceRequestRejected
                            ? t("Invoice edits were rejected")
                            : data.isEditInvoiceRequested
                              ? t("Edit Invoice (Request Pending)")
                              : t("Edit Invoice")
                      }
                      onClick={() => handleEditButtonClick(data?.invoiceNumber, data?.dueDate)}
                      disabled={data.isEditInvoiceRequested || data?.isHaveCreditInvoice || data?.isCreditInvoiceRequested}
                      style={{
                        color:
                          data.isEditInvoiceRequested && data.isEditInvoiceRequestApproved
                            ? "green"
                            : data.isEditInvoiceRequested && data.isEditInvoiceRequestRejected
                              ? "red"
                              : undefined,
                        borderColor:
                          data.isEditInvoiceRequested && data.isEditInvoiceRequestApproved
                            ? "green"
                            : data.isEditInvoiceRequested && data.isEditInvoiceRequestRejected
                              ? "red"
                              : undefined,
                        pointerEvents:
                          !!data.isEditInvoiceRequested && !data.isEditInvoiceRequestApproved && !data.isEditInvoiceRequestRejected
                            ? "none"
                            : undefined,
                        opacity:
                          !!data.isEditInvoiceRequested && !data.isEditInvoiceRequestApproved && !data.isEditInvoiceRequestRejected
                            ? 0.5
                            : data?.isHaveCreditInvoice ? 0.5 : data?.isCreditInvoiceRequested ? 0.5 : 1,
                      }}
                    >
                      <FaEdit size={14} />
                    </button>
                  </div>
                )}
                 
                <div>
                  <button 
                    id="top" 
                    className="salary_view" 
                    data-toggle="tooltip"  
                    data-placement="top" 
                    title={data?.isHaveCreditInvoice ? t("Credit note already requested") : t("Request Credit Note")} 
                    onClick={() => handleAmountButtonClick(data?.invoiceNumber, data?.amount)}
                    disabled={data?.isHaveCreditInvoice || data.isEditInvoiceRequested || data?.isSalaryCreated}
                    style={{
                      opacity: data?.isHaveCreditInvoice ? 0.5 : data.isEditInvoiceRequested ? 0.5 : data?.isSalaryCreated ? 0.5 : 1,
                      pointerEvents: data?.isHaveCreditInvoice ? "none" : undefined,
                      cursor: data?.isHaveCreditInvoice ? "not-allowed" : "pointer"
                    }}
                  >
                    <MdCancel />
                  </button>
                </div> 
                {/* {data.isSalaryCreated === false &&(
                      <div>
                        <button id="top" className="salary_view" data-toggle="tooltip" data-placement="top" title={t("Request cancellation")}
                        style={{ opacity: data?.isHaveCreditInvoice ? 0.5 : 1, pointerEvents: data?.isHaveCreditInvoice ? "none" : undefined, cursor: data?.isHaveCreditInvoice ? "not-allowed" : "pointer" }}
                        disabled={data?.isHaveCreditInvoice} onClick={() => handleCancelButtonClick(data?.invoiceNumber)}>
                          <MdCancel />
                        </button>
                      </div> )} */}
                     

                      <div data-toggle="tooltip" data-placement="top" title={!isLoginWithBankId ? t("To access express payment, please log in with BankID.") : data?.customer?.paymentTerm == "45" || data?.customer?.paymentTerm == "60" ? t("We don't accept express payment for 45 & 60 days.") : data?.customer?.accountType === 1 ? t("We don't accept express payment for private customers.") : data?.amount > 60000 ? t("For Express Payment, there is a limit of SEK 60,000 per invoice.") : isPastDueDate(data?.dueDate) ? t("Express payment is not available after the due date.") : ""}>
                        <Form.Group controlId="formBasicCheckbox">
                          {
                          data?.expressPayout
                            || !isLoginWithBankId
                            || data?.customer?.country !== "Sweden"
                            || data?.customer?.paymentTerm == "45"
                            || data?.customer?.paymentTerm == "60"
                            || data?.customer?.accountType === 1
                            || data?.amount > 60000
                            || isPastDueDate(data?.dueDate) ? (
                            <img
                              alt="express-pay-icon"
                              src={language === LOCALES.EN_US ? "/assets/express-pay-icon.png" : "/assets/express-pay-icon-swe.png"}
                              style={{
                                width: "60px",
                                boxShadow: "rgba(144, 115, 195, 0.21) 0px 2px 21px",
                                border: "1px solid #5d47b6",
                                opacity: "0.5",
                                filter: "grayscale(100%)",
                                pointerEvents: "none",
                              }}
                              className="shadow px-1 py-1 bg-white rounded ml-1 cursor-not-allowed"
                            />
                          ) : (
                            <img
                              src={language === LOCALES.EN_US ? "/assets/express-pay-icon.png" : "/assets/express-pay-icon-swe.png"}
                              alt="express-pay-icon"
                              style={{
                                width: "60px",
                                boxShadow: "rgba(144, 115, 195, 0.21) 0px 2px 21px",
                                border: "1px solid #5d47b6",
                              }}
                              className="shadow px-1 py-1 bg-white rounded ml-1 cursor-pointer"
                              onClick={() => {
                                setShowDetails((prevState) => ({
                                  ...prevState,
                                  expresePayment: data,
                                  expresePolicy: true,
                                }));
                              }}
                            />
                          )}
                        </Form.Group>
                      </div>

                      <div>
                        {data?.expressPayout && (
                          <button style={{ cursor: "auto" }} id="top" data-toggle="tooltip" data-placement="top" title={t("Express payment applied.")}>
                            <CiCircleCheck fontSize="20px" style={{ color: "green" }} />
                          </button>
                        )}
                      </div>

                      {isAuthorize ? (
                        <div style={{ position: "relative", display: "inline-block", textAlign: "center" }}>
                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{data.isAuthorizedForReminder ? t("Reminder Already Authorized") : t("Click here to Authorize")}</Tooltip>}>
                            <span className="d-inline-block">
                              <NotificationAddIcon
                                style={{
                                  color: data.isAuthorizedForReminder ? "gray" : "#5d47b6",
                                  fontSize: "30px",
                                  cursor: data.isAuthorizedForReminder ? "not-allowed" : "pointer",
                                  animation: data.isAuthorizedForReminder ? "none" : "blink 1s infinite, glow 1.5s infinite",
                                  transition: "transform 0.3s ease-in-out",
                                  opacity: data.isAuthorizedForReminder ? 0.6 : 1,
                                }}
                                onClick={!data.isAuthorizedForReminder ? handleAuthorizedReminder : undefined}
                              />
                            </span>
                          </OverlayTrigger>
                        </div>
                      ) : (
                        ""
                      )}

                      {data.isAuthorizedForReminder === true && (!isAuthorize || isAuthorize === "") ? (
                        <div style={{ position: "relative", display: "inline-block", textAlign: "center" }}>
                          <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{data.isAuthorizedForReminder ? t("Reminder Already Authorized") : t("Click here to Authorize")}</Tooltip>}>
                            <span className="d-inline-block">
                              <NotificationAddIcon
                                style={{
                                  color: data.isAuthorizedForReminder ? "gray" : "#5d47b6",
                                  fontSize: "30px",
                                  cursor: data.isAuthorizedForReminder ? "not-allowed" : "pointer",
                                  animation: data.isAuthorizedForReminder ? "none" : "blink 1s infinite, glow 1.5s infinite",
                                  transition: "transform 0.3s ease-in-out",
                                  opacity: data.isAuthorizedForReminder ? 0.6 : 1,
                                }}
                                onClick={!data.isAuthorizedForReminder ? handleAuthorizedReminder : undefined}
                              />
                            </span>
                          </OverlayTrigger>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                  )
                );
              })
            ) : (
              <tr>
                <td colSpan="9">
                  <h6>{t("No data found")}</h6>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="paginationInvoice">
        <Pagination style={{ flexWrap: "wrap" }}>{items}</Pagination>
        <br />
      </div>
      {/* Edit amount modal start */}
      <InvoiceEditAmountModal showAmountModal={showAmountModal} handleAmountModalClose={handleAmountModalClose} handleAmountChange={handleAmountChange} amount={amount} editInvoiceData={editInvoiceData} setShowAmountModal={setShowAmountModal} invoices={invoices} fetchInvoices={fetchInvoices} />
      {/* Edit amount modal end */}

      {/* Cancel invoice modal start */}
      <CancelInvoiceModal showCancelModal={showCancelModal} handleCancelModalClose={handleCancelModalClose} handleConfirmCancel={handleConfirmCancel} cancelInvoiceNumber={cancelInvoiceNumber} />
      {/* Cancel invoice modal end */}

      {/* Edit Invoice modal start */}
      <EditInvoiceModal showEditModal={showEditModal} handleModalClose={handleModalClose} handleFormChange={handleFormChange} editInvoiceData={editInvoiceData} setShowEditModal={setShowEditModal} />
      {/* Edit Invoice modal End */}

      {showDetails.expresePayment && (
        <Modal
          className="model_read_invoice"
          show={true}
          size="sm"
          centered
          onHide={() =>
            setShowDetails((prevState) => ({
              ...prevState,
              expresePayment: null,
              closeModal: true,
            }))
          }
        >
          <Modal.Header>
            <AiOutlineClose
              className="ml-auto cursor-pointer"
              size={24}
              onClick={() =>
                setShowDetails((prevState) => ({
                  ...prevState,
                  expresePayment: null,
                  closeModal: true,
                }))
              }
            />
          </Modal.Header>
          <Modal.Body>
            <div className="page-content EconomyInvoices m-0">
              <div className=" invoice-details-title">
                <span className="d-flex">{!showDetails.expresePayment?.expressPayout ? t("Have you read our terms and accept them all for express payment?") : t("You have Already Done express payment for this invoice")}</span>
                {!showDetails.expresePayment?.expressPayout && (
                  <>
                    <Button variant="outline-primary" className="m-2" size="sm" onClick={() => handleExPaymentClick(showDetails.expresePayment)}>
                      {t("Yes")}
                    </Button>
                    <Button
                      variant="outline-primary"
                      className="m-2"
                      size="sm"
                      onClick={() =>
                        setShowDetails((prevState) => ({
                          ...prevState,
                          expresePayment: null,
                          closeModal: true,
                        }))
                      }
                    >
                      {t("No")}
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="outline_btn_new"
              onClick={() =>
                setShowDetails((prevState) => ({
                  ...prevState,
                  expresePayment: null,
                  closeModal: true,
                }))
              }
            >
              {t("Close")}
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {showDetails.expresePolicy && (
        <Modal
          size="lg"
          show={showDetails.expresePolicy}
          onHide={() =>
            setShowDetails((prevState) => ({
              ...prevState,
              expresePolicy: false,
            }))
          }
        >
          <Modal.Header>
            <Modal.Title>{t("Express payment")}</Modal.Title>
            <AiOutlineClose
              className="ml-auto cursor-pointer"
              size={24}
              onClick={() =>
                setShowDetails((prevState) => ({
                  ...prevState,
                  expresePolicy: false,
                }))
              }
            />
          </Modal.Header>
          <Modal.Body>
            <p>{t("To qualify for Express Payment with Invozio")}</p>
            <p>{t("Payment of your salary is made on the same day")}</p>
            <p>{t("Conditions for 'Approved' status include no payment remarks")}</p>
          </Modal.Body>
        </Modal>
      )}
    </Layout>
  );
};

export default Invoices;
